// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class PFixTradingWebhookResponseMessage extends PFixMessage {
    get id() {
        return this.getFieldValue(FieldsFactory.FIELD_ID);
    }
    get apiKey() {
        return this.getFieldValue(FieldsFactory.FIELD_KEY);
    }
    get secretKey() {
        return this.getFieldValue(FieldsFactory.FIELD_PASSWORD);
    }
    get createdAt() {
        return this.getFieldValue(FieldsFactory.FIELD_CREATED_AT);
    }
    get expireAt() {
        return this.getFieldValue(FieldsFactory.FIELD_EXPIRE_AT);
    }
    get name() {
        return this.getFieldValue(FieldsFactory.FIELD_NAME);
    }
    get status() {
        return this.getFieldValue(FieldsFactory.FIELD_STATUS);
    }
    constructor(fieldSet) {
        super(Message.CODE_TRADING_WEBHOOK_RESPONSE, fieldSet);
    }
}
